import { WebConfig } from '~/config/shopConfig'
import { GQLMenuItem } from '~/graphql/__generated__/interfaces'

interface menuIconsRedesign {
  name: string
  imageId: string
  imageRedesignId: string
}

export const LOGIN_ICON_ID = '81372620'
export const LOGIN_ICON_ID_TEST = '32886982'

export const LOGOUT_ICON_ID = '81372616'
export const LOGOUT_ICON_ID_TEST = '32886961'

export function addMenuRedesignIconId(
  items: GQLMenuItem[],
  webConfig: WebConfig
) {
  const icons: menuIconsRedesign[] = webConfig.menuIconsRedesign
    ? JSON.parse(webConfig.menuIconsRedesign) ?? []
    : []

  return icons.length
    ? items.map((item) => {
        const icon = icons.find((icon) => icon.imageId === item.image?.imageId)
        return icon
          ? {
              ...item,
              image: {
                ...item.image,
                imageIdRedesign: icon.imageRedesignId,
              },
            }
          : item
      })
    : items
}
